import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Typography,
  Alert,
  SelectChangeEvent 
} from '@mui/material';
import { Account } from '../../hooks/useAccounts';

interface AccountSelectorProps {
  accounts: Account[];
  value: string;
  onChange: (e: SelectChangeEvent) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
}

const AccountSelector: React.FC<AccountSelectorProps> = ({
  accounts,
  value,
  onChange,
  error,
  required = true,
  disabled = false
}) => {
  const label = `Account${required ? ' *' : ''}`;

  return (
    <>
      <FormControl fullWidth margin="normal">
        <InputLabel id="account-label">{label}</InputLabel>
        <Select
          labelId="account-label"
          id="accountId"
          name="accountId"
          value={value || ''}
          label={label}
          onChange={onChange}
          error={!!error}
          disabled={disabled}
        >
          {accounts.length > 0 ? (
            accounts.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                {account.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled value="">
              No accounts available
            </MenuItem>
          )}
        </Select>
        {error && (
          <Typography color="error" variant="caption">
            {error}
          </Typography>
        )}
      </FormControl>
      
      {accounts.length === 0 && (
        <Alert severity="info" sx={{ mt: 1 }}>
          You need to add an account before creating content. Go to Settings → Manage Accounts to add one.
        </Alert>
      )}
    </>
  );
};

export default AccountSelector; 